<template>

  <div class="card" @click="$router.push({path: `/images/${item._id}`})">
    <div class="text-center fade-out">
      <img v-if="item.url" class="card-img-top img-fluid" :src="item.url">
    </div>
    <div class="card-body">
      <div v-if="item.description" v-html="$embers.markdown(item.description)"></div>
      <footer class="card-text">
        <div class="row">
          <div class="col">
            
            <small class="text-muted">{{item.origin}}</small>
          </div>
          <div class="col text-right">
            <small class="text-muted">{{imageSize}}</small>
          </div>
        </div>
        <small class="text-muted" v-if="isAdmin">{{item._user.name}}</small>
      </footer>
    </div>
  </div>

</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "image-card",
  props: ["item"],
  data() {
    return {
      showViewModal: false,
      showEditModal: false
    };
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    ...mapState({
      user: state => state.session.user
    }),
    isOwner() {
      let iOwn = false;
      if (this.item._user && this.item._user._id) {
        iOwn = this.user._id === this.item._user._id;
        /* eslint-disable-next-line vue/no-side-effects-in-computed-properties */
        if (!iOwn && !this.isAdmin) this.$router.push({ path: `/403` });
      }
      return iOwn;
    },
    imageSize() {
      let size = 0;
      if (typeof this.item.size === "number")
        size = (this.item.size / 1024).toFixed(1) + "k";

      return size;
    }
  }
};
</script>
